import React, { FC, useState } from 'react'

import EditIcon from '@mui/icons-material/Edit'

import useIsMounted from '../../../../../../hooks/useIsMounted'
import { CoachInitialPswdTooltip, CoachInitialPswdCopyBtn } from './styled'
import AppUserInitialPswd from '../../../../../../components/AppUserInitialPswd/AppUserInitialPswd'

interface CoachOverviewInitialPswdProps {
	readonly initialPswd: string
}

const CoachOverviewInitialPswd: FC<CoachOverviewInitialPswdProps> = ({
	initialPswd,
}: CoachOverviewInitialPswdProps) => {
	const isMounted = useIsMounted()
	const [tooltipLabel, setTooltipLabel] = useState<string>('Click to copy')

	const handleCopyPswd: React.MouseEventHandler<HTMLButtonElement> = () => {
		navigator.clipboard.writeText(initialPswd)
		setTooltipLabel('Copied!')
	}

	const handleCloseTooltip = (): void => {
		setTimeout(() => {
			isMounted() && setTooltipLabel('Click to copy')
		}, 250)
	}

	return (
		<AppUserInitialPswd
			initialPassword={initialPswd}
			onClick={handleCopyPswd}
			wrapperSx={{ ml: 'auto' }}
			renderCustomButton={onClick => (
				<CoachInitialPswdCopyBtn size={'small'} onClick={onClick}>
					<CoachInitialPswdTooltip
						title={tooltipLabel}
						placement='top'
						shadow={true}
						onClose={handleCloseTooltip}
					>
						<EditIcon fontSize={'inherit'} />
					</CoachInitialPswdTooltip>
				</CoachInitialPswdCopyBtn>
			)}
		/>
	)
}

export default CoachOverviewInitialPswd
